import { useTranslation } from '@/i18n';
import { useCallback, useMemo, useRef, useState } from 'react';
import { DEFAULT_ANCHOR, getAnchorItems } from './anchorData';
import { useScrollToAnchor } from './useScrollToAnchor';
import { useScrollDetection } from './useScrollDetection';
import { useAnchorClick } from './useAnchorClick';
export const useHandleAnchor = (
  contentWrapperRef: React.RefObject<HTMLDivElement>
) => {
  const [currentAnchor, setCurrentAnchor] = useState<string>(DEFAULT_ANCHOR);
  const isClickingRef = useRef(false);
  const isInitializingRef = useRef(true);

  const { t } = useTranslation();
  const anchorItems = useMemo(() => getAnchorItems(t), [t]);
  useScrollToAnchor(
    contentWrapperRef,
    isClickingRef,
    isInitializingRef,
    setCurrentAnchor,
    anchorItems
  );
  useScrollDetection(
    contentWrapperRef,
    isClickingRef,
    isInitializingRef,
    setCurrentAnchor,
    anchorItems
  );

  const { handleAnchorClick } = useAnchorClick(
    contentWrapperRef,
    isClickingRef,
    setCurrentAnchor,
    anchorItems
  );

  const getContainer = useCallback(() => {
    return contentWrapperRef.current || window;
  }, [contentWrapperRef]);

  const getCurrentAnchor = useCallback(() => {
    return currentAnchor;
  }, [currentAnchor]);

  return {
    currentAnchor,
    handleAnchorClick,
    anchorItems,
    getContainer,
    getCurrentAnchor,
  };
};
